export function StepNumber({ n, rotate }: { n: string; rotate: string }) {
  return (
    <div
      className="relative flex justify-center pt-1 gap-4 row-span-2"
      aria-hidden="true"
    >
      <span
        className="font-bold select-none block text-dark-blue"
        style={{
          fontSize: 'clamp(3.5rem, 8vw, 7rem)',
          lineHeight: '0.85',
          transform: `rotate(${rotate})`,
        }}
      >
        {n}
      </span>
    </div>
  );
}
